import FormJaivana from 'dashboard_jaivana_v1';

/**
 *
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */

class CustomAlistamientoEnvasadoFinal extends FormJaivana.form {
    constructor(props){
        super(props);

        this.initForm = this.initForm.bind(this);
        this.successDatosFicha = this.successDatosFicha.bind(this);
        this.succesDatosTablaAlistaEnv = this.succesDatosTablaAlistaEnv.bind(this);
        this.grabarAlistaEnv = this.grabarAlistaEnv.bind(this);
        this.setButtonAbastecer = this.setButtonAbastecer.bind(this);
        this.setChangeButtonAbastecer = this.setChangeButtonAbastecer.bind(this);
        this.succesButtonAbastecer = this.succesButtonAbastecer.bind(this);
        this.uploadTableAlistaEnv = this.uploadTableAlistaEnv.bind(this);
        this.archivoPDF                 = this.archivoPDF.bind(this);
        this.successArchivoPDF          = this.successArchivoPDF.bind(this);
        this.verFormula                 = this.verFormula.bind(this);
        this.successVerFormula          = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula      = Object.assign({}, this.gridOptions);
    }

    initForm(){
        console.log('CustomAlistamientoEnvasadoFinal @version: 1.01.0054 @author: Santiago_Hernandez; @updateBy Sebastian Rios Echverri');

        this.archivoPDF();
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '445-Servicio_traer_datos_fichas_items_ali_env'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successDatosFicha,
                error:this.error_,
                general: this.generalFormat
            });*/

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'porleer', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.succesDatosTablaAlistaEnv,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*let bodys = {
                value: this.props.data.id_ficha, 
            }
        this.generalFormat.nombre_accion = '445-Servicio_traer_items_tabla_alistamiento_envasado_porleer'; 
        this.service.send(
            {
            endpoint:this.constant.formConfiguration(),
            method:'GET',
            body:bodys,
            success:this.succesDatosTablaAlistaEnv,
            error:this.error_,
            general: this.generalFormat,
            showMessage :false
            });*/

        this.getField('btnGrabarAlistaEnv').setClick(this.grabarAlistaEnv);
        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    archivoPDF(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
                detalle: "Material empaque envasado"
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'urlalistamiento', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successArchivoPDF,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*
        produccion_fichas-urlalistamiento
        this.generalFormat.nombre_accion = '445-produccion_fichas-urlalistamiento'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: bodys,
                success: this.successArchivoPDF,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successArchivoPDF(data){
        console.log('url alistamiento ==>', data.data);
        if(data.estado_p === 200){
            let codigo_bodega = data.data[0].codigo_bodega;
            let TamanoArch = data.data.length;

            let urlArray = [];
            let url = [];

            for (let i = 0; i < TamanoArch; i++){
                url.push(data.data[i].url_alistamiento);
                let text = 'PDF material empaque, bodega ';
                urlArray.push("<li><a href= '" + url[i] + "' target='_blank'>" + text + codigo_bodega + "</a></li>");
            }

            let etiqueta = "<ul>" + urlArray + "</ul>";
            this.getField('archivo').setValue(etiqueta);

            //let url = data.data[0].url_alistamiento;
            //let text = 'PDF Material empaque'
            //let etiquetaHTML = "<a href='" + url + "' target='_blank'>" + text + "</a>";
            //this.getField('archivo').setValue(etiquetaHTML);
            //console.log('url alistamiento ==>', data,this.getField('archivo').getValue());
        }
    }
    successDatosFicha(data){
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            this.getField('listaAlistaEnv').setVisible(true);
            this.getField('listaAlistaEnv').setItemsFichas(data.model);
        }else{
            this.getField('listaAlistaEnv').setVisible(false);
        }
    }

    succesDatosTablaAlistaEnv(data){
        //console.log('entro al succesdatostablaAlistaenv',data);
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            
            this.gridOptions['rowData']=[];
            this.getField('tablaAlistaEnv').initData(this.gridOptions);
            this.getField('tablaAlistaEnv').toggle(true);
            let configCellcol = new Map();
            configCellcol.set('accion', {cellRenderer:this.setButtonAbastecer, field:'Acción'});

            this.gridOptions['rowData'] = data.model;
            this.getField('tablaAlistaEnv').initData(this.gridOptions,configCellcol);

            //this.gridOptionsTablaAlistaEnv.paginationPageSize = 100;
        }else{ 
          this.getField('tablaAlistaEnv').toggle(false);
          //this.getField('fieldAlert').toggle(true,"No hay material de empaque","error");
        }
    }

    setButtonAbastecer(props){
        let button = document.createElement("input");
        button.onclick = () => this.setChangeButtonAbastecer(props.data);
        button.setAttribute("class","buttonStyle");
        button.setAttribute("type","button");
        button.setAttribute("value","Abastecer");
        return this.createElementJaivana(button); 
        
    }

    setChangeButtonAbastecer(data){
        let datos = {
            datos:{
                id: data.id
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'leer', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.succesButtonAbastecer,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '445-servicio_boton_abastecer_alistamiento_envasado_final'; 
        this.service.send(
        {
            endpoint:this.constant.formConfiguration(),
            method:'PUT',
            body:body,
            success:this.succesButtonAbastecer,
            error:this.error_,
            general: this.generalFormat
        });*/
    }

    succesButtonAbastecer(data){
        //console.log('entro al successbutonabastecer',data);
        if(data.estado_p === 200){
            this.uploadTableAlistaEnv();
        }
    }

    uploadTableAlistaEnv(){
        this.getField('btnGrabarAlistaEnv').setDisabled(false);
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'porleer', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.succesDatosTablaAlistaEnv,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*
        this.generalFormat.nombre_accion = '445-Servicio_traer_items_tabla_alistamiento_envasado_porleer'; 
        this.service.send(
            {
            endpoint:this.constant.formConfiguration(),
            method:'GET',
            body:body,
            success:this.succesDatosTablaAlistaEnv,
            error:this.error_,
            general: this.generalFormat,
            showMessage :false
            });*/

    }

    grabarAlistaEnv(){
        let datos = {
            datos:{
                proceso_id: this.props.data.proceso_id,
                actividad_configuracion_id: this.props.data.actividad_configuracion_id,
                actividad_id: this.props.data.actividad_id,
                produccion_fichas_id: this.props.data.id_ficha
            }
        }
        this.getField('btnGrabarAlistaEnv').setDisabled(true);

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'alistar', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successCloseEstage,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '445-Servicio_alistamiento_envasado_final_boton_grabar'; 
        this.service.send(
            {
            endpoint:this.constant.formConfiguration(),
            method:'POST',
            body:body,
            success:this.successCloseEstage,
            error:this.error_,
            general: this.generalFormat
            });*/
    }

}

export default CustomAlistamientoEnvasadoFinal; 
FormJaivana.addController("prod-alistamientoenvasado",CustomAlistamientoEnvasadoFinal);